export default __webpack_public_path__ + "static/media/tokenImage.abd0b77a.svg";